module.exports = __webpack_public_path__ + "e.no2.256fd23d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/nakagawa/e.no2.jpg
// module id = aRmi
// module chunks = 0